import { Map } from 'immutable';
import {
    GET_SURVEY_AGES,
    GET_SURVEY_AGES_SUCCESS,
    GET_SURVEY_AGES_FAILURE,
    GET_SURVEY_GENDERS,
    GET_SURVEY_GENDERS_SUCCESS,
    GET_SURVEY_GENDERS_FAILURE
} from 'constants/actionTypes';

const init = Map({});

export default function preliminaryQuestionsReducer(state = init, action) {
    switch (action.type) {
    case GET_SURVEY_AGES:
        return state;
    case GET_SURVEY_AGES_SUCCESS:
        return state.merge({ ages: action.payload });
    case GET_SURVEY_AGES_FAILURE:
        return state.merge({ errors: action.payload });
    case GET_SURVEY_GENDERS:
        return state;
    case GET_SURVEY_GENDERS_SUCCESS:
        return state.merge({ genders: action.payload });
    case GET_SURVEY_GENDERS_FAILURE:
        return state.merge({ errors: action.payload });
    default:
        return state;
    }
}
